import common from './common';
import emptySettings from './empty-settings';

export default {
  common,
  emptySettings,
};
